import config from '@/appConfig';

export default {
  methods: {
    newsImage: ( image, size = 'res337x250' ) => {
      if (!image) return null;
      const { links } = image;
      const path = links[size] || links.original;
      if (!path) return null;
      return config.imgUrl + path;
    },
  },
};
